export const csvHeaders = Object.freeze({
  Accept: 'text/csv',
  'Content-Type': 'text/csv',
});
